/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useState, useCallback } from 'react';

import { FaChevronDown } from 'react-icons/fa';
import ResultsHeader from './resultsPartials/ResultsHeader';

const ResultsCategories = ({
  categories,
  activeCategory,
  setActiveCategory
}) => {
  const [dropActive, setDropActive] = useState(false);

  const toggleDrop = useCallback(() => {
    setDropActive(val => !val);
  });

  const categoryClicked = useCallback(cat => {
    setDropActive(val => !val);
    setActiveCategory(cat);
  });

  return (
    <div className="container container-full text-format">
      <div className="navigation-beam results-beam">
        <div className="container">
          <ResultsHeader />
          <div className="tt-category">Select category:</div>
          <div className="nav-category">
            {categories.map(category => (
              <button
                key={category}
                className={`item-category ${
                  category === activeCategory ? 'active' : ''
                }`}
                onClick={() => categoryClicked(category)}
                type="button"
              >
                {category}
              </button>
            ))}
          </div>
          <div className="mobile-menu">
            <div className="nav-post-xs visible-xs">
              {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
              <div
                className={`main-select ${dropActive ? 'active' : ''}`}
                id="show-post-menu"
                onClick={toggleDrop}
              >
                <div className="select-active">{activeCategory}</div>
                <div className="select-icon">
                  <FaChevronDown
                    id="drop-icon"
                    className={dropActive ? 'rotate' : ''}
                  />
                </div>
              </div>
              <div
                className={`drop-select nav nav-tabs ${
                  dropActive ? 'show' : ''
                }`}
                id="drop-select"
              >
                {categories.map(category => (
                  <div
                    key={category}
                    className={`item-category-drop ${
                      category === activeCategory ? 'active' : ''
                    }`}
                    onClick={() => categoryClicked(category)}
                    role="button"
                  >
                    {category}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultsCategories;
